import type { Dayjs } from 'dayjs';
import type { AppointmentDTO } from 'src/types/dto/appointment.dto';
import type { DateRange } from 'src/components/range-availability-calendar';

import dayjs from 'dayjs';

export const getDefaultAvailabilityWindow = (
  startDate?: string | Date,
  dueDate?: string | Date
): DateRange => {
  const from = startDate ? dayjs(startDate).startOf('day') : dayjs().startOf('day');
  const to = dueDate ? dayjs(dueDate).startOf('day') : from.add(3, 'month');

  if (to.isBefore(from, 'day')) {
    return { from, to: from.add(3, 'month') };
  }

  return { from, to };
};

export const getDefaultPreferredRange = (appointment?: AppointmentDTO): DateRange | undefined => {
  if (!appointment?.from) {
    return undefined;
  }

  const anchor = dayjs(appointment.from).startOf('day');

  return {
    from: anchor.subtract(3, 'day'),
    to: anchor.add(3, 'day'),
  };
};

export const formatSelectedDates = (dates: Dayjs[]) =>
  dates.map((date) => date.format('YYYY-MM-DD'));
